import { FIBER_POP_BULK_DELETE } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const bulkDeleteFiberPopSites = async (ids) => {
  try {
    const response = await apiClient.delete(FIBER_POP_BULK_DELETE, {
      data: { ids },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
